@if (showGridHeader$ | async) {
<div class="row no-gutters align-items-center header-row">
  <div
    class="col-12 col-md-4 d-flex justify-content-center justify-content-md-start align-items-center cursor-pointer"
  >
    @if (showInboundDetailsLink$ | async) {
    <div
      class="mb-2 mb-md-0 inbound-details-button"
      (click)="setVisibilityOfInboundDetails(true)"
    >
      <fa-icon class="mr-2" [icon]="['fas', 'truck']" size="sm"></fa-icon>
      <span
        i18n="ConfigStrip|view inbound details label@@viewInboundDetailsLabel"
      >
        <u class="text-underline font-weight-bold">Click here</u> to view
        Inbound Details
      </span>
    </div>
    }
  </div>
  <div
    class="col-12 col-md-4 d-flex justify-content-center align-items-center mb-md-0"
    [class.mb-2]="showLegend$ | async"
  >
    @if ({ switcherTooltip: switcherTooltip$ | async, aMdoEnabled:
    selectedAdvancedMdoEnabled$ | async, hasSizes: hasLooseSizes$ | async,
    hasPrePacks: hasPrepacks$ | async, showToggle: showToggle$ | async,
    selectedDisplayMode: selectedDisplayByMode$ | async }; as observables) { @if
    (observables.showToggle) {
    <epc-toggle-display-mode
      [displayByMode]="observables.selectedDisplayMode"
      [showSizes]="observables.hasSizes"
      [showPrepacks]="observables.hasPrePacks"
      (changedDisplayMode)="changeDisplayByMode($event)"
    >
    </epc-toggle-display-mode>
    } }
  </div>
  <div class="col-12 col-md-4 grid-legend">
    @if (showLegend$ | async) {
    <div class="grid-legend-item">
      <div class="legend-item-color-indicator backorder"></div>
      <span
        i18n="
          Size Grid|Available later grid legend
          label@@availableLaterGridLegendLabel"
        >Available later</span
      >
    </div>
    <div class="grid-legend-item">
      <div class="legend-item-color-indicator unavailable"></div>
      <span
        i18n="
          Size Grid|Unavailable material grid legend
          label@@unavailableMaterialGridLegendLabel"
        >Unavailable</span
      >
    </div>
    } @if ( (showLegend$ | async) === false && (selectedAdvancedMdoEnabled$ |
    async) ) {
    <atx-switch class="switcher" [formControl]="compactControl">
      <ng-container i18n="ConfigStrip@@advancedMdoCompactMode"
        >Compact mode</ng-container
      >
    </atx-switch>
    }
  </div>
</div>
}
<epc-inbound-details
  [showDetails]="openInboundDetails$$ | async"
  (toggleView)="setVisibilityOfInboundDetails($event)"
>
</epc-inbound-details>
